// extracted by mini-css-extract-plugin
module.exports = {"mainFooterContainer":"Footer_mainFooterContainer__1eN6Q","links":"Footer_links__CCzWI","linkEntry":"Footer_linkEntry__c6oOC"};